import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ServiceContent from './ServiceSections/ServiceContent';
import IndustryUseCases from './ServiceSections/IndustryUseCases';
import ServiceFAQ from './ServiceSections/ServiceFAQ';
import ServiceRichText from './ServiceSections/ServiceRichText';
import { allServicesData, CompleteServiceData } from '../data/allServicesData';
import '../styles/ServiceDetailPage.css';
import '../styles/ServiceSections.css';
import ServiceHeroSection from './ServiceSections/ServiceHeroSection';
import DividerShowcase from './Divider';

const EnhancedServiceDetailPage: React.FC = () => {
  const { serviceId } = useParams<{ serviceId: string }>();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Get service data from the comprehensive data structure
  const service: CompleteServiceData | null = serviceId ? allServicesData[serviceId] : null;

  if (!service) {
    return (
      <div className="service-detail-page">
        <div className="service-not-found">
          <h1>404</h1>
          <p>The service you're looking for doesn't exist or may have been moved.</p>
          <Link to="/services" className="back-to-services-btn">
            Explore All Services
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="service-detail-page">
      {/* Enhanced Breadcrumb */}
      <div className="betaque-service-breadcrumb">
        <Link to="/">Home</Link> / <Link to="/services">Services</Link> / {service.hero.title}
      </div>

      {/* Hero Section */}
      <ServiceHeroSection {...service.hero} />

      {/* Main Content Sections */}
      <ServiceContent sections={service.content.sections} />

      {/* Additional Rich Text Sections */}
      {service.additionalSections?.map((section, index) => (
        <ServiceRichText
          key={index}
          title={section.title}
          content={section.content}
          variant={section.variant}
        />
      ))}
  
      {/* <DividerShowcase /> */}

      {/* Industry Use Cases */}
      {service.industryUseCases && (
        <IndustryUseCases {...service.industryUseCases} />
      )}

      {/* FAQ Section */}
      {service.faq && (
        <ServiceFAQ {...service.faq} />
      )}
    </div>
  );
};

export default EnhancedServiceDetailPage; 